import React from 'react'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'

import {
  QuizDispatchContext,
  QuizStoreContext,
} from '../../contexts/quizContext'

import { T, O } from '../../utils/Typography'
import RadioItem from './RadioItem'
import { OptionId, optionsDict } from '../../data/options'
import FormGroup, { FormGroupProps } from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

interface CheckboxGroupProps extends FormGroupProps {
  options: OptionId[]
  handleChange: ({ option: OptionType, checked: boolean }) => void
}
const CheckboxGroup = ({ options, handleChange }: CheckboxGroupProps) => {
  const { quizAnswers, quizIndex } = React.useContext(QuizStoreContext)
  return (
    <FormGroup>
      {options.map((option_key) => {
        if (optionsDict[option_key] === undefined) {
          throw new Error(`optionsDict is undefined for option: ${option_key}`)
        }
        return (
          <FormControlLabel
            key={option_key}
            control={
              <Checkbox
                checked={Boolean(quizAnswers[quizIndex][option_key])}
                onChange={(e) =>
                  handleChange({
                    option: e.target.name as OptionId,
                    checked: e.target.checked,
                  })
                }
                name={option_key}
              />
            }
            label={optionsDict[option_key]!.content}
          />
        )
      })}
    </FormGroup>
  )
}

export default CheckboxGroup
